import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import styled from '@mui/material/styles/styled';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ModalButtons from './ModalButtons';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
}));

const Modal = ({
  action,
  openModal,
  title,
  children,
  form,
  deleteButton,
  showActions,
  handleClose,
  handleConfirm,
  ...restProps
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={openModal} fullWidth {...restProps}>
      <DialogTitle aria-label="modal title">{title}</DialogTitle>
      <StyledIconButton aria-label="close" onClick={handleClose} size="large">
        <CloseIcon />
      </StyledIconButton>
      <DialogContent sx={{ pt: 1 }}>
        {children}
        {form}
      </DialogContent>

      {showActions && (
        <ModalButtons
          danger={deleteButton}
          onCancel={handleClose}
          onAction={handleConfirm}
          actionText={
            deleteButton
              ? t('delete', { ns: 'buttons' })
              : t('confirm', { ns: 'buttons' })
          }
        />
      )}
      {action}
    </Dialog>
  );
};

Modal.propTypes = {
  action: PropTypes.node,
  openModal: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  form: PropTypes.element,
  deleteButton: PropTypes.bool,
  showActions: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func,
};

export default Modal;
